<template>
  <div>
    <div class="page-title-nav row">
      <div class="col-2 col-lg-3">
        <router-link to="/member/home" class="btn btn-outline-secondary btn-custom btn-back">
          <i class="fa-icon fa-regular fa-arrow-left me-0"></i>
          <span class="d-none d-lg-block ms-2">ย้อนกลับ</span>
        </router-link>

      </div>
      <div class="col-8 col-lg-6">
        <h1 class="page-title">เล่นเกม</h1>
      </div>
      <div class="col-12 col-lg-3">
        <a href="#" class="btn btn-primary btn-custom d-none"><i
            class="fa-icon fa-regular fa-home"></i><span>button</span></a>
      </div>
    </div>
    <div class="row mb-4">
      <div class="col-6 d-grid">
        <router-link :class="getActiveGamelist() + ``" class="btn  btn-custom btn-xl" :to="`/member/gamelist`">
          <i class="fa-icon fa-regular fa-gamepad-modern"></i>เกมส์
        </router-link>

      </div>
      <div class="col-6 d-grid">
        <router-link :class="getActiveHistory()" class="btn  btn-custom btn-xl" :to="`/member/gamehistory`">
          <i class="fa-icon fa-regular fa-clock-rotate-left"></i>ประวัติการเล่น
        </router-link>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      link: window.location.pathname
    }
  },
  created () {

  },
  methods: {
    getActiveHistory () {
      if (this.link === '/member/gamehistory') {
        return 'btn-label-secondary'
      } else {
        return 'btn-outline-secondary'
      }
    },
    getActiveGamelist () {
      if (this.link === '/member/gamelist') {
        return 'btn-label-secondary'
      } else {
        return 'btn-outline-secondary'
      }
    }

  },
  computed: {

  },
  watch: {

  },
  mounted () {
    console.log('Component mounted!')
  }
}
</script>
